export default __webpack_public_path__ + "static/media/polkadotLogo.fbd6b0a6.svg";